/**
 * @generated SignedSource<<f8061546fb8862cf3b8a768bcf98a622>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type sprint_nativeIssueTable_SprintCell$data = {
  readonly " $fragmentSpreads": FragmentRefs<"sprint_nativeIssueTable_SprintCellInternalOld_fieldRef" | "sprint_nativeIssueTable_SprintCellInternal_fieldRef">;
  readonly " $fragmentType": "sprint_nativeIssueTable_SprintCell";
};
export type sprint_nativeIssueTable_SprintCell$key = {
  readonly " $data"?: sprint_nativeIssueTable_SprintCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"sprint_nativeIssueTable_SprintCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "sprint_nativeIssueTable_SprintCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "sprint_nativeIssueTable_SprintCellInternalOld_fieldRef"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcsprintinlineeditrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isInlineEditingEnabled",
              "variableName": "isInlineEditingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "sprint_nativeIssueTable_SprintCellInternal_fieldRef"
        }
      ]
    }
  ],
  "type": "JiraSprintField"
};

(node as any).hash = "014f403450995cac6b170d3902c83117";

export default node;
